module.exports = __webpack_public_path__ + "static/media/6.Greece bucket.65a14fdf.jpg";